<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/colors";

  .list-item-wrapper {
    width: 100%;
    margin: 0;
    padding: utils.in_rem(8px) utils.in_rem(12px);
    align-items: center;
    border-radius: 10px;
    display: flex;
    gap: utils.in_rem(8px);

    .list-item-content {
      width: 100%;
      word-break: break-word;
      @include mixins.body2();
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      .list-item-label {
        display: flex;
        gap: utils.in_rem(8px);
        align-items: center;

        > span {
          width: 100%;
          @include mixins.body2();
        }

        > img {
          width: utils.in_rem(20px);
          height: utils.in_rem(20px);
        }

        .icon-wrapper {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          justify-content: center;
          width: utils.in_rem(20px);
          height: utils.in_rem(20px);
        }
      }

      .list-item-description {
        overflow: hidden;
        @include colors.color(textGrey);
        text-overflow: ellipsis;
        @include mixins.body4();
        max-width: 140px;
      }
    }

    cursor: pointer;

    &:hover:not(.disabled) {
      @include colors.background-color(primary_5);
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    &[aria-selected="true"] {
      &.show-checkbox {
        &:not(.toggle-all) {
          @include colors.color(primary_50);
        }
      }

      &:not(.show-checkbox) {
        @include colors.background-color(primary_10);
      }
    }
  }

  .wrapper {
    width: utils.in_rem(24px);
    height: utils.in_rem(24px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<script>
  import Checkbox from "../../../../src/svelte/src/components/legacy/Checkbox.svelte";
  import Icon from "../../atoms/Icon.svelte";
  import Tooltip from "../../atoms/Tooltip.svelte";

  export let icon = "";
  export let src = "";
  export let imgStyle = "";
  export let description = "";
  export let alt = "Icon";
  export let onclick = () => {};
  export let selected = false;
  export let disabled = false;
  export let placement = "left";
  export let showCheckbox = false; // For multi-select dropdowns
  export let checkboxSide = "right";
  export let partial = false; // E.g. for a select all option
  export let toggleOption = false; // Set to true for select all option, so the styling is different
  export let style = "";
  export let descriptionStyle = "";

  const internalOnclick = () => {
    if (disabled) return;
    selected = !selected;
    onclick(selected);
  };

  const onkeydown = (e) => {
    if (disabled) return;
    if (!["Enter", " "].includes(e.key)) return;
    e.preventDefault();
    internalOnclick();
  };
</script>

{#if $$slots.tooltip}
  <Tooltip
    {placement}
    let:onmouseenter
    let:onmouseleave
    let:onblur
    let:onfocus
    let:dismiss
  >
    <span slot="tooltip"><slot name="tooltip" /></span>
    <div
      tabindex="0"
      on:mouseenter={onmouseenter}
      on:mouseleave={onmouseleave}
      on:blur={onblur}
      on:focus={onfocus}
      on:click={() => {
        dismiss();
        internalOnclick();
      }}
      on:keydown={(e) => {
        dismiss();
        onkeydown(e);
      }}
      role="option"
      aria-selected={selected}
      class:show-checkbox={showCheckbox}
      class:toggle-all={toggleOption}
      class:disabled
      class="list-item-wrapper"
      {style}
    >
      {#if showCheckbox && checkboxSide === "left"}
        <Checkbox checked={selected} />
      {/if}
      <div class="list-item-content">
        <div class="list-item-label">
          {#if icon}
            <div class="icon-wrapper">
              <Icon class={icon} />
            </div>
          {:else if src}
            <img style={imgStyle} {src} {alt} />
          {/if}
          <span>
            <slot />
          </span>
        </div>
        {#if description}
          <span class="list-item-description" style={descriptionStyle}
            >{description}</span
          >
        {/if}
      </div>
      {#if showCheckbox && checkboxSide === "right"}
        <Checkbox checked={selected} />
      {/if}
    </div>
  </Tooltip>
{:else}
  <div
    tabindex="0"
    on:click={internalOnclick}
    on:keydown={onkeydown}
    role="option"
    aria-selected={selected}
    class:show-checkbox={showCheckbox}
    class:toggle-all={toggleOption}
    class:disabled
    class="list-item-wrapper"
    {style}
  >
    {#if showCheckbox && checkboxSide === "left"}
      <Checkbox checked={selected} {partial} runClick={false} />
    {/if}
    <div class="list-item-content">
      <div class="list-item-label">
        {#if icon}
          <div class="icon-wrapper">
            <Icon class={icon} />
          </div>
        {:else if src}
          <img style={imgStyle} {src} {alt} />
        {/if}
        <span>
          <slot />
        </span>
      </div>
      {#if description}
        <span class="list-item-description" style={descriptionStyle}
          >{description}</span
        >
      {/if}
    </div>
    {#if showCheckbox && checkboxSide === "right"}
      <Checkbox checked={selected} {partial} runClick={false} />
    {/if}
  </div>
{/if}
